import { OctagonWarningContainedIcon } from '@ankr.com/ui';

import { BUNDLE_USAGE_TRESHOLDS } from 'modules/billing/constants';

export interface BundleStatusIconProps {
  classes: { error: string; warning: string };
  left: number;
}

export const BundleStatusIcon = ({ classes, left }: BundleStatusIconProps) => {
  if (left < BUNDLE_USAGE_TRESHOLDS.error) {
    return <OctagonWarningContainedIcon className={classes.error} size={20} />;
  }

  if (left < BUNDLE_USAGE_TRESHOLDS.warning) {
    return (
      <OctagonWarningContainedIcon className={classes.warning} size={20} />
    );
  }

  return null;
};
